module.exports = __webpack_public_path__ + "8d606381715297a22ca083bd35ebc0d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1_variable/public/picture/Dining.jpg
// module id = 372
// module chunks = 0